import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMyApiKeysQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetMyApiKeysQuery = {
  __typename?: 'Query';
  myApiKeys: Array<{
    __typename?: 'ApiKey';
    id: any;
    label: string;
    keyType: Types.ApiKeyType;
    createdAt: any;
    lastUsedAt?: any | null;
    userId?: any | null;
    teamId?: any | null;
  }>;
};

export const GetMyApiKeysDocument = gql`
  query GetMyApiKeys {
    myApiKeys {
      id
      label
      keyType
      createdAt
      lastUsedAt
      userId
      teamId
    }
  }
`;

/**
 * __useGetMyApiKeysQuery__
 *
 * To run a query within a React component, call `useGetMyApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyApiKeysQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyApiKeysQuery,
    GetMyApiKeysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyApiKeysQuery, GetMyApiKeysQueryVariables>(
    GetMyApiKeysDocument,
    options,
  );
}
export function useGetMyApiKeysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyApiKeysQuery,
    GetMyApiKeysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyApiKeysQuery, GetMyApiKeysQueryVariables>(
    GetMyApiKeysDocument,
    options,
  );
}
export function useGetMyApiKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyApiKeysQuery,
        GetMyApiKeysQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMyApiKeysQuery, GetMyApiKeysQueryVariables>(
    GetMyApiKeysDocument,
    options,
  );
}
export type GetMyApiKeysQueryHookResult = ReturnType<
  typeof useGetMyApiKeysQuery
>;
export type GetMyApiKeysLazyQueryHookResult = ReturnType<
  typeof useGetMyApiKeysLazyQuery
>;
export type GetMyApiKeysSuspenseQueryHookResult = ReturnType<
  typeof useGetMyApiKeysSuspenseQuery
>;
export type GetMyApiKeysQueryResult = Apollo.QueryResult<
  GetMyApiKeysQuery,
  GetMyApiKeysQueryVariables
>;
